import { Fieldset } from 'components/Form/FormHelper/Fieldset';
import { LegendVariant } from 'components/Form/FormHelper/Fieldset/Legend';
import React, { useId } from 'react';
import 'twin.macro';
import { Radio } from 'components/Form/Radios/Radio';
import { TwStyle } from 'twin.macro';

export interface Option<T> {
  label: React.ReactNode;
  value: T;
  description?: string;
  disabled?: boolean;
}

export interface Props<T> {
  value: T;
  onChange: (value: T) => void;
  options: Option<T>[];
  label?: string;
  className?: string;
  required?: boolean;
  name?: string;
  legendStyle?: TwStyle;
  legendVariant?: LegendVariant;
}

export function Radios<T>({
  options,
  value,
  onChange,
  label,
  className,
  required,
  name,
  legendVariant = 'quiet',
  legendStyle,
}: Props<T>) {
  const reactId = useId();
  const groupName = name ?? `radios-${reactId}`;
  const groupId = `radios-${reactId}`;

  return (
    <Fieldset
      className={className}
      legendStyle={legendStyle}
      legendVariant={legendVariant}
      label={label}
    >
      <div tw="space-y-2">
        {options.map((opt, index) => {
          const id = `${groupId}-${index}`;

          return (
            <Radio
              key={opt.value as string}
              id={id}
              name={groupName}
              label={opt.label}
              description={opt.description}
              checked={value === opt.value}
              disabled={opt.disabled}
              required={required}
              onChange={() => onChange(opt.value)}
            />
          );
        })}
      </div>
    </Fieldset>
  );
}
